export default __webpack_public_path__ + "static/media/0004.b107c61e.WAV";